import { render, staticRenderFns } from "./scienceWx.vue?vue&type=template&id=b5ce5e7a&scoped=true&"
import script from "./scienceWx.vue?vue&type=script&lang=js&"
export * from "./scienceWx.vue?vue&type=script&lang=js&"
import style0 from "./scienceWx.vue?vue&type=style&index=0&id=b5ce5e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ce5e7a",
  null
  
)

component.options.__file = "scienceWx.vue"
export default component.exports